<template>
    <oc-page title="Dashboard" id="dashbaord">
        <h4 class="section-title">Dashboard</h4>
        <div class="hr" />

        <oc-dashboard
            v-if="items.length > 0"
            :data="items"
            defaultItemsColor="#846f79"
            class="mt-4"
            v-class="{'container-fluid': false}"
        />

        <p v-else class="mt-3">No results found!</p>
    </oc-page>
</template>

<script>
import AuthStateMixin from '@/mixins/AuthStateMixin'

export default {
    name: "app-dashboard",
    mixins: [AuthStateMixin],
    data() {
        return {
            items: []
        }
    },
    mounted() {
        API.GET('app', 'dashboard').then(resp => {
            let data = resp.getData()

            this.items = []

            data.forEach(item => {
                this.items.push({
                    tag: 'a',
                    target: '_blank',
                    href: item.link,
                    title: item.title,
                    icon: item.icon
                })
            })
        })
    }
}
</script>

<style scoped>
#dashbaord >>> .dash-row ul li {
    width: 18em;
    margin: 0em 1.2em 1.2em 0em;
}
</style>
